/**
 * Route guard for admin surfaces (spec 020 §10). The platform has exactly
 * one admin (`user.is_admin`); there is no per-app admin role.
 *
 * PR #85 review (owner decision): an authenticated non-admin sees an
 * Access Denied panel in place, not a silent redirect. An unauthenticated
 * (null) user still goes to /login — belt-and-braces, since ProtectedRoute
 * normally handles that case before this guard ever mounts.
 */
import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

import { useAuthStore } from '@/stores/authStore';
import { AccessDenied } from './AccessDenied';

export function RequirePlatformAdmin({ children }: { children: ReactNode }) {
  const user = useAuthStore((s) => s.user);
  if (!user) return <Navigate to="/login" replace />;
  if (!user.is_admin) return <AccessDenied message="You do not have admin privileges." />;
  return <>{children}</>;
}
